import { Component, OnInit, Input } from '@angular/core';
import { SmartLabelTemplate } from '../smart-label-template';
import { SmartLabelService } from '../smart-label.service';
import { PageService } from '../../../services/page.service';
import { AppService } from '../../../services/app.service';
@Component({
  selector: 'smart-label-non-food',
  templateUrl: './smart-label-non-food.component.html',
  styleUrls: ['./smart-label-non-food.component.scss']
})
export class SmartLabelNonFoodComponent extends SmartLabelTemplate implements OnInit {
  @Input() config;
  @Input() smartLabelData;
  @Input() entityInformation;
  pageAlias = '';
  privacyPolicyUrl;

  //Configs
  headerConfig: any;
  tabConfig: any = { config: null };
  productHeaderConfig: any;
  footerLinksConfig;
  footer1Config: any;
  footer2Config: any;
  disclosureConfig: any;
  externalLinksConfig: any;
  usageAndHandlingConfig: any;
  ingredientsConfig: any;
  socialLinksConfig: any;
  informationAccuracyConfig: any;


  //Data
  imageLinkPath: string = 'data.modules.BasicProductInformationModuleType.imageLink';

  ingredientListPath: string = 'data.modules.NonfoodIngredientInformationModuleType.nonfoodIngredient';
  ingredientStatementPath: string = 'data.modules.NonfoodIngredientInformationModuleType.nonfoodIngredientStatement.0';

  gpcCategoryCodePath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';

  brandNamePath: string = 'data.modules.BasicProductInformationModuleType.brandNameInformation.brandName';

  categoryPath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';

  productImageUrlPath: string = 'data.modules.BasicProductInformationModuleType.imageLink';

  nonfoodIngredientInformationPath: string = "data.modules.NonfoodIngredientInformationModuleType";
  sdsLinkConfig;
  constructor(private smartLabelService: SmartLabelService,
    private pageService: PageService,
    private appService: AppService) {
    super();
  }

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {

    //console.log(this.config);
    this.pageAlias = this.pageService.pageAlias;

    // Assign smartLabel data to service variable
    this.smartLabelService.smartLabelData = this.smartLabelData; //this.appService.listCodeTranslate(this.smartLabelData);
    //console.log('this.smartLabelData', this.smartLabelData)
    //console.log(this.smartLabelService.getProductImages(this.productImageUrlPath, 0))
    this.smartLabelService.smartLabelConfig = this.config;
    this.privacyPolicyUrl = this.smartLabelService.getPrivacyPolicyUrl(this.config);


    this.headerConfig = {
      "ctrlName": "header",
      "config": {
        "sticky": true,
        "isBackButtonVisible": false,
        "isMenuButtonVisible": false,
        "isContentHeader": true,
        "bgImageColor": "#FFFFFF",
        "class": 'smartlabel-header'
      }
    }

    this.productHeaderConfig = this.smartLabelService.getProductHeaderConfig();



    if (this.config.hasOwnProperty('footer1')) {
      // this.footer1Config = {
      //   "ctrlName": "footer",
      //   "config": {
      //     "sticky": false,
      //     "isContentFooter": true,
      //     "content": this.config.footer1,
      //     "class": "smartlabel-footer"
      //   }
      // }

      this.footer1Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer m-b-10",
          "content": this.config.footer1,
        }
      }



    }

    if (this.config.hasOwnProperty('footer2')) {
      // this.footer2Config = {
      //   "ctrlName": "footer",
      //   "config": {
      //     "sticky": false,
      //     "isContentFooter": true,
      //     "content": this.config.footer2,
      //     "class": "smartlabel-footer"
      //   }
      // }

      this.footer2Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer",
          "content": this.config.footer2,
        }
      }
    }





    this.footerLinksConfig = {
      "ctrlName": "footer-links",
      "config": {
        "class": "smartlabel-footer-links",
        "links": [
          ...(this.privacyPolicyUrl ? [this.privacyPolicyUrl] : [])
        ]
      }
    }

    //set disclosureConfig by fragrance/non-fragrance level
    //console.log("category",this.smartLabelData.product.productCategory)
    if (this.smartLabelService.isCategoryHousehold() && this.smartLabelService.isSubjectToCARegulations()) {
      this.disclosureConfig = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text p-16",
          "content": `Ingredients below that appear on Designated Lists or are fragrance allergens included on Annex
          III of the EU Cosmetics Regulation No. 1223/2009 are indicated by the <span><ion-badge mode="ios" class="smartlabel-badge">DL</ion-badge></span> symbol.
          <p>
            <a class="page-link" href="p/${this.pageService.pageAlias}?detail=designated-list">Learn more about Designated Lists</a>
          </p>`
        }
      }
    } else {
      this.disclosureConfig = this.smartLabelService.getDisclosureLevelConfig(this.nonfoodIngredientInformationPath);
    }


    this.externalLinksConfig = this.smartLabelService.getExternalLinksConfig(this.config);
    //  console.log('EXTERNAL', this.externalLinksConfig);

    this.usageAndHandlingConfig = this.smartLabelService.getUsageAndHandlingConfig();

    this.ingredientsConfig = this.getIngredientsConfig();

    this.socialLinksConfig = this.smartLabelService.getSocialLinksConfig();
    let sds = this.smartLabelService.getProductInfoLink("SDS", "Safety Data Sheet");
    //check if productCategory is household and it is subjectToCARegulations
    if (this.smartLabelService.isCategoryHousehold() && this.smartLabelService.isSubjectToCARegulations()) {
      //check if SDS is present in smartlabelData
      if (sds) {
        this.sdsLinkConfig = {
          "ctrlName": "list",
          "config": {
            "class": "smartlabel-list"
          },
          "controls": [
            sds
          ]
        }
      }
    }

    // console.log('Before TabConfig')
    // console.log({
    //   disclosureConfig: this.disclosureConfig,
    //   ingredientsConfig: this.ingredientsConfig,
    //   sdsLinkConfig: this.sdsLinkConfig
    // })

    this.tabConfig =
    {
      "ctrlName": "tabs",
      "config": {
        "class": 'smartlabel-tabs',
        "value": 'ingredients-and-contents',
        "layout": 'icon-top',
        "scrollable": false,
        "tabs": 5,
        "sticky": true,
        "gridFixed": true
      },
      "controls": [
        {
          "ctrlName": "tab-item",
          "config": {
            "name": 'ingredients-and-contents',
            "title": 'Ingredients & Contents',
            "icon": ['fas', 'list'],
            "show": true
          },
          "controls": [
            (this.disclosureConfig ? this.disclosureConfig : []),
            ...(this.ingredientsConfig ? this.ingredientsConfig : []),
            (this.sdsLinkConfig ? this.sdsLinkConfig : [])

          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": 'health-safety-and-environment',
            "title": 'Health, Safety & Environment',
            "icon": ['fas', 'exclamation-triangle'],
            "show": true
          },
          "controls": [
            this.tab2Config()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": 'usage-and-handling',
            "title": 'Usage & Handling',
            "icon": ['far', 'hand-point-up'],
            "show": true
          },
          "controls": [
            ...(this.usageAndHandlingConfig ? [this.usageAndHandlingConfig] : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": 'about-this-product',
            "title": 'About this Product',
            "icon": ['fas', 'info-circle'],
            "show": true
          },
          "controls": [
            this.tab4Config()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": 'company-brand-and-sustainability',
            "title": 'Company, Brand & Sustainability',
            "icon": ['fas', 'external-link-square-alt'],
            "show": true
          },
          "controls": [
            this.getContactTabsConfig(this.config),
            this.externalLinksConfig
          ]
        }

      ]
    }
    //console.log('imgurl in component', this.smartLabelService.getProductImages(this.imageLinkPath))
    //console.log('getingredient',this.smartLabelService.getIngredientsByList(this.ingredientListPath))
    //console.log('getIngredientsByStatement', this.smartLabelService.getIngredientsByStatement(this.ingredientStatementPath))
    //console.log('getGPCCategorycode', this.smartLabelService.getGpcCategoryCode(this.gpcCategoryCodePath));
    //console.log('getBrandName', this.smartLabelService.getBrandName(this.brandNamePath))
    //console.log('getNonFragranceDisclosureConfig', this.smartLabelService.getNonFragranceDisclosureConfig(3))
    //console.log('getFragranceDisclosureConfig', this.smartLabelService.getFragranceDisclosureConfig(3))

    this.informationAccuracyConfig = this.smartLabelService.getInformationAccuracyConfig();

  }

  /**
  * [create list for health-safety-and-environment]
  * @author Lalitkumar Saindane
  * @return [listConfig]
  */
  tab2Config() {
    let listConfig;
    let item;

    listConfig = {
      "ctrlName": "list",
      "title": "Health, Safety &amp; Environment",
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };

    if (this.smartLabelService.getEffectsOnHumanHealthPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Human Health ',
          "url": { "url": `p/${this.pageAlias}?detail=human-health`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getStorageAndDisposalList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Storage and Disposal',
          "url": { "url": `p/${this.pageAlias}?detail=storage-and-disposal`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getProductSustainabilityModuleTypeList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Environment',
          "url": { "url": `p/${this.pageAlias}?detail=environment`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    return listConfig;

  }

  /**
 * [create list for feature-and-benefits]
 * @author Lalitkumar Saindane
 * @return [listConfig]
 */
  tab4Config() {
    let listConfig;
    let item;

    listConfig = {
      "ctrlName": "list",
      "title": "Health, Safety &amp; Environment",
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };

    if (this.smartLabelService.getAboutProductPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Features & Benefits',
          "url": { "url": `p/${this.pageAlias}?detail=about-product`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getCertificationsList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'Certifications',
          "url": { "url": `p/${this.pageAlias}?detail=certifications`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    if (this.smartLabelService.getGeneralInfoPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": 'General Information',
          "url": { "url": `p/${this.pageAlias}?detail=general-information`, "type": "detail" }
        }
      };
      listConfig.controls.push(item);
    }

    return listConfig;

  }
  /**
  * [Set button-segments to company-brand-and-sustainabilit]
  * @param  config  [object contain emailId and phoneNumber ]
  * @author Lalitkumar Saindane
  * @return [button-segments]
  */
  getContactTabsConfig(config) {
    let button;
    let segment;

    if (typeof config === 'object') {

      button = {
        "ctrlName": "button-segments",
        "config": {
          "class": "smartlabel-button-segments",
          "segments": []
        }
      };

      if (config.hasOwnProperty('email') && config.email) {

        segment = {
          "title": "Contact Us",
          "icon": ['far', 'envelope'],
          "link": `mailto:${config.email}`,
          "tooltip": `<p style="text-align: center; color: #fff; font-family: 'Trebuchet MS' !important; padding: 10px 0; margin: 0; font-size: 12px; font-weight: bold;">${config.email}</p>`,
          "tooltipClass": "smartlabel-tooltip"
        };
        button.config.segments.push(segment);
      }

      if (config.hasOwnProperty('phone') && config.phone) {

        segment = {
          "title": "Call Us",
          "icon": "phone",
          "link": `tel:${config.phone}`,
          "tooltip": `<p style="text-align: center; color: #fff; font-family: 'Trebuchet MS' !important; padding: 10px 0; margin: 0; font-size: 12px; font-weight: bold;">${config.phone}</p>`,
          "tooltipClass": "smartlabel-tooltip"
        };
        button.config.segments.push(segment);
      }
    }

    return button;

  }

  /**
   * [Return ingredients from statement or module]
   * @author Neil
   * @return [description]
   */
  getIngredientsConfig() {
    //console.log(this.nonfoodIngredientInformationPath);

    let ingredientsList = [];
    let ingredientListConfig;
    let inactiveIngredientListConfig;

    let activeIngredientHeadingConfig;
    let inactiveIngredientHeadingConfig;

    ingredientsList = this.smartLabelService.getIngredientsByList(this.nonfoodIngredientInformationPath + '.nonfoodIngredient');

    //First check if ingredients have the isActive attribute
    let hasIsActive = (item) => {
      return item.hasOwnProperty('isActive');
    }

    if (ingredientsList.some(hasIsActive)) {
      //active ingredients
      ingredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList, 0, 0, 'active');

      if (ingredientListConfig.controls.length > 0) {

        activeIngredientHeadingConfig =
        {
          "ctrlName": "heading",
          "config": {
            "class": "smartlabel-ingredient-heading p-16 p-t-0 p-b-0",
            "text": "ACTIVE INGREDIENTS",
            "headingType": 2
          }
        }
      }


      //inactive ingredients
      inactiveIngredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList, 0, 0, 'inactive');


      if (inactiveIngredientListConfig.controls.length > 0) {

        inactiveIngredientHeadingConfig =
        {
          "ctrlName": "heading",
          "config": {
            "class": "smartlabel-ingredient-heading p-16 p-t-0 p-b-0",
            "text": "NON-ACTIVE INGREDIENTS",
            "headingType": 2
          }
        }
      }



    } else {
      ingredientListConfig = this.smartLabelService.ingredientListConfig(ingredientsList);
    }





    //console.log('COC', ingredientListConfig);




    if (ingredientsList.length > 0) {

      let result = [];

      if (activeIngredientHeadingConfig) {
        result.push(activeIngredientHeadingConfig)
      }

      if (ingredientListConfig) {
        result.push(ingredientListConfig)
      }

      if (inactiveIngredientHeadingConfig) {
        result.push(inactiveIngredientHeadingConfig)
      }

      if (inactiveIngredientListConfig) {
        result.push(inactiveIngredientListConfig)
      }

      return result;

    } else {
      //NOTE: use language listener

      ingredientsList = [...this.smartLabelService.getIngredientsByStatement(this.nonfoodIngredientInformationPath + '.nonfoodIngredientStatement')];
      let list: any;
      let controls = [];
      //console.log('ingredientsList', ingredientsList);
      if (ingredientsList.length > 0) {
        list = {
          "ctrlName": "list",
          "title": "Ingredients List",
          "config": {
            "class": "smartlabel-list"
          },
          "controls": []
        }



        for (const ingredient of ingredientsList) {
          controls.push(
            {
              "ctrlName": "list-item",
              "config": {
                "label": ingredient
              }
            },
          )
        }



        list.controls = [...controls];


      }

      return [list];

    }

  }

}
